import { PathwayKey, pathwaysData } from 'constants/WorkingModePathwaysConstants'

interface PathwayToggleProps {
  active: PathwayKey
  onChange: (key: PathwayKey) => void
}

export const PathwayToggle = ({ active, onChange }: PathwayToggleProps) => (
  <div className="flex gap-3 items-start w-full">
    {(Object.keys(pathwaysData) as PathwayKey[]).map(key => (
      <button
        key={key}
        type="button"
        className={`pathway-toggle-pill ${active === key ? 'pathway-toggle-pill--active' : ''}`}
        onClick={() => onChange(key)}
      >
        {pathwaysData[key].pillLabel}
      </button>
    ))}
  </div>
)
